"use strict";
import { useEffect } from "react";
export const useTranslateY = ({
  ref,
  shouldTranslate,
  yTransformValue,
  durationMs = 300
}) => {
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.backgroundColor = "white";
    el.style.transition = `transform ${durationMs}ms ease-in-out`;
    el.style.transform = shouldTranslate ? `translateY(${yTransformValue})` : "translateY(0)";
  }, [ref, shouldTranslate, yTransformValue, durationMs]);
};
